import { Cart } from '@shared/types/cart/Cart';
import { sdk } from '@/sdk/CommercetoolsSDK';

export class CartService {
    baseUrl: string;
    subscriptionKey: string;
    endpoints: Record<string, string>;
    cartDetailsPromise: any;

    constructor() {
        this.baseUrl = 'https://api-uber-stage.gwabk.com.au/plumbershub/cart/';
        this.subscriptionKey = '1f6708ac934a49fa9417c92993b06960';
        this.endpoints = {
            getCart: `${this.baseUrl}/cart`,
            addToCart: `${this.baseUrl}/add-to-cart`,
            updateItemQuantity: `${this.baseUrl}/update-quantity`,
            removeItem: `${this.baseUrl}/remove-item-from-cart`,
            removeAllItems: `${this.baseUrl}/remove-all-items-from-cart`,
            validateCart: `${this.baseUrl}/validate-cart`
        }
        this.cartDetailsPromise = null;
    }

    public getEndpoint(key: string) {
        return this.endpoints[key] ?? '';
    }

    public async getCart({ currency, businessUnitKey, storeKey }: { currency: string, businessUnitKey: string, storeKey: string }): Promise<Cart | null> {
        try {
            this.cartDetailsPromise = null;
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.getCart({
                currency,
                "companyKey": "",
                storeKey: storeKey
            });
        } catch (e) {
            this.cartDetailsPromise = null;
            console.log('failed to fetch cart:: error:', e);
            return null;
        }
    }

    public async addToCart({ currency, businessUnitKey, variantSku, quantity = 1, variantKey, storeKey }: { currency: string, businessUnitKey: string, variantSku: string, variantKey: string, quantity?: number, storeKey: string }): Promise<Cart | null> {
        try {
            this.cartDetailsPromise = null;
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.addToCart({
                variantSku,
                variantKey,
                quantity,
                currency,
                "companyKey": "",
                storeKey: storeKey
            });
        } catch (e) {
            console.log('failed to add to cart:: error:', e);
            return null;
        }
    }

    public async updateItemQuantity({ currency, businessUnitKey, variantSku, variantKey, quantity = 1, storeKey }: { currency: string, businessUnitKey: string, variantSku: string, quantity?: number, variantKey: any, storeKey: string }): Promise<Cart | null> {
        try {
            this.cartDetailsPromise = null;
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.updateItemQuantity({
                quantity,
                currency,
                "companyKey": businessUnitKey,
                variantSku,
                variantKey,
                storeKey
            });
        } catch (e) {
            console.log('failed to update cart:: error:', e);
            return null;
        }
    }

    public async removeItem({ currency, businessUnitKey, variantSku, storeKey }: { currency: string, businessUnitKey: string, variantSku: string, storeKey: string }): Promise<Cart | null> {
        try {
            this.cartDetailsPromise = null;
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.removeItem({
                variantSku,
                currency,
                "companyKey": businessUnitKey,
                storeKey: storeKey
            });
        } catch (e) {
            console.log('failed to remove from cart:: error:', e);
            return null;
        }
    }

    public async removeAllItems({ currency, businessUnitKey, storeKey }: { currency: string, businessUnitKey: string, storeKey: string }): Promise<Cart | null> {
        try {
            this.cartDetailsPromise = null;
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.removeAllItems({
                currency,
                "companyKey": businessUnitKey,
                storeKey: storeKey
            });
        } catch (e) {
            console.log('failed to add to cart:: error:', e);
            return null;
        }
    }

    public async addCoupon({ currency, discountCode, storeKey }: { currency: string, discountCode: string, storeKey: string }): Promise<Cart | null> {
        try {
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.addCoupon({
                discountCode,
                currency,
                storeKey,
            });
        } catch (e) {
            console.log('failed to add coupon:: error:', e);
            return null;
        }
    }

    public async removeCoupon({ currency, discountCode, storeKey }: { currency: string, discountCode: string, storeKey: string }): Promise<Cart | null> {
        try {
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.removeCoupon({
                discountCode,
                currency,
                storeKey,
            });
        } catch (e) {
            console.log('failed to remove coupon:: error:', e);
            return null;
        }
    }

    public async validateCart({ currency, companyKey }: { currency: string, companyKey: string }): Promise<Cart | null> {
        try {
            const extensions = sdk.composableCommerce;
            return extensions.checkoutCart.validateCart({
                currency,
                companyKey
            });
        } catch (e) {
            console.log('failed to validate cart:: error:', e);
            return null;
        }
    }

    public async submitOrder({ currency, companyKey }: { currency: string, companyKey: string }): Promise<Cart | null> {
        try {
            const extensions = sdk.composableCommerce;
            this.cartDetailsPromise = null;
            return extensions.checkoutCart.submitOrder({
                currency,
                companyKey
            });
        } catch (e) {
            console.log('failed to submit cart for order:: error:', e);
            return null;
        }
    }
    public async createOrder({ currency, transactionId, ctOrderNumber, brochureOrderNumber }: { currency: string, transactionId?: string, ctOrderNumber?: string, brochureOrderNumber?: string }): Promise<Cart | null> {
        try {
            const extensions = sdk.composableCommerce;
            this.cartDetailsPromise = null;
            return extensions.checkoutCart.createOrder({
                currency,
                transactionId,
                ctOrderNumber,
                brochureOrderNumber,
            });
        } catch (e) {
            console.log('failed to submit cart for order:: error:', e);
            return null;
        }
    }
}
const cartservice = new CartService();

export default cartservice;
